import { useState, useEffect, useCallback } from "react";
import {
  Button,
  Box,
  Typography,
  Stack,
  Chip,
  Card,
  CardContent,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Divider,
  Alert,
  Collapse,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { DirectionsCar, CheckCircle, ArrowForwardIos, ArrowBackIos, Person, Phone, Hotel } from "@mui/icons-material";

const theme = createTheme({
  direction: "rtl",
  typography: { fontFamily: '"Cairo", "Tajawal", Arial, sans-serif' },
  palette: {
    primary: { main: "#4183c5" },
  },
});

const API_BASE = "https://dash.tatabu.io/back-end/public/api";
// const API_BASE = "http://localhost:8000/api";

const carsData = {
  serviceOneCars: {
    label: "توصيل من جدة إلى مكة",
    emoji: "🕋",
    cars: [
      { id: 1, model: "هيونداي ستاريا", year: 2026, seats: 7, price: 295, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/D.png" },
      { id: 2, model: "كامري", year: 2026, seats: 4, price: 295, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/A.png" },
      { id: 3, model: "فورد تورس", year: 2026, seats: 4, price: 295, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/BB.png" },
      { id: 4, model: "جي ام سي", year: 2026, seats: 7, price: 495, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/CCC.png" },
      { id: 5, model: "باص هايس", year: 2026, seats: 10, price: 495, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/EE.png" },
    ],
  },
  serviceTwoCars: {
    label: "ذهاب وعودة من جدة إلى مكة",
    emoji: "🕋",
    cars: [
      { id: 6, model: "هيونداي ستاريا", year: 2026, seats: 7, price: 550, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/D.png" },
      { id: 7, model: "كامري", year: 2026, seats: 4, price: 550, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/A.png" },
      { id: 8, model: "فورد تورس", year: 2026, seats: 4, price: 550, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/BB.png" },
      { id: 9, model: "جي ام سي", year: 2026, seats: 7, price: 995, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/CCC.png" },
      { id: 10, model: "باص هايس", year: 2026, seats: 10, price: 850, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/EE.png" },
    ],
  },
  serviceFiveCars: {
    label: "توصيل من مكة الى جدة",
    emoji: "🕋",
    cars: [
      { id: 11, model: "هيونداي ستاريا", year: 2026, seats: 7, price: 330, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/D.png" },
      { id: 12, model: "كامري", year: 2026, seats: 4, price: 245, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/A.png" },
      { id: 13, model: "فورد تورس", year: 2026, seats: 4, price: 300, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/BB.png" },
      { id: 14, model: "جي ام سي", year: 2026, seats: 7, price: 540, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/CCC.png" },
      { id: 15, model: "باص هايس", year: 2026, seats: 10, price: 445, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/EE.png" },
    ],
  },
  serviceThreeCars: {
    label: "توصيل من جدة إلى المدينة",
    emoji: "🕌",
    cars: [
      { id: 16, model: "هيونداي ستاريا", year: 2026, seats: 7, price: 750, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/D.png" },
      { id: 17, model: "كامري", year: 2026, seats: 4, price: 595, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/A.png" },
      { id: 18, model: "فورد تورس", year: 2026, seats: 4, price: 695, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/BB.png" },
      { id: 19, model: "جي ام سي", year: 2026, seats: 7, price: 1095, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/CCC.png" },
      { id: 20, model: "باص هايس", year: 2026, seats: 10, price: 850, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/EE.png" },
    ],
  },
  serviceFourCars: {
    label: "توصيل من مكة إلى المدينة",
    emoji: "🕌",
    cars: [
      { id: 21, model: "هيونداي ستاريا", year: 2026, seats: 7, price: 690, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/D.png" },
      { id: 22, model: "كامري", year: 2026, seats: 4, price: 550, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/A.png" },
      { id: 23, model: "فورد تورس", year: 2026, seats: 4, price: 650, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/BB.png" },
      { id: 24, model: "جي ام سي", year: 2026, seats: 7, price: 1095, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/CCC.png" },
      { id: 25, model: "باص هايس", year: 2026, seats: 10, price: 850, image: "/wp-content/themes/huda-alharamin-theme/assets/images/cars/EE.png" },
    ],
  },
};

const SARIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} style={{ verticalAlign: "middle", marginRight: 2 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39">
    <path fill={color} d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
    <path
      fill={color}
      d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"
    />
  </svg>
);

const initialForm = {
  name: "",
  phone: "",
  pickup_location: "airport",
  neighborhood: "",
  pickup_date: "",
  pickup_hour: "",
  hotel_name: "",
  extra_route_access: false,
  images: [], // New field
};

// ─── Step Dot ─────────────────────────────────────────────────────────────────
const StepDot = ({ index, currentStep, label }) => (
  <Stack alignItems="center" gap={0.5}>
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        bgcolor: currentStep >= index ? "#fff" : "#e0e0e0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.3s",
      }}
    >
      {currentStep > index ? (
        <CheckCircle sx={{ fontSize: 18, color: "#4183c5" }} />
      ) : (
        <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.75rem", fontWeight: 700, color: currentStep >= index ? "#4183c5" : "#aaa" }}>{index + 1}</Typography>
      )}
    </Box>
    <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.65rem", color: currentStep >= index ? "#ffffff" : "#aaa", fontWeight: currentStep >= index ? 700 : 400 }}>
      {label}
    </Typography>
  </Stack>
);

// ─── Step 0: Service Selection ────────────────────────────────────────────────
const ServiceStep = ({ onSelectService }) => {
  const serviceKeys = Object.keys(carsData);
  return (
    <Box>
      <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.05rem", color: "#1a1a2e", mb: 0.5, textAlign: "center" }}>اختر نوع الخدمة</Typography>
      <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.8rem", color: "#888", mb: 2.5, textAlign: "center" }}>حدد وجهة السفر المطلوبة</Typography>
      <Grid container spacing={2}>
        {serviceKeys.map((key) => {
          const svc = carsData[key];
          return (
            <Grid item xs={12} sm={6} key={key}>
              <Card
                onClick={() => onSelectService(key)}
                elevation={0}
                sx={{
                  borderRadius: 3,
                  border: "1.5px solid #e8e0f5",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": { border: "1.5px solid #4183c5", boxShadow: "0 4px 20px rgba(98,62,151,0.12)", transform: "translateY(-2px)" },
                }}
              >
                <CardContent sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: 2,
                      bgcolor: "#f3eeff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.6rem",
                      flexShrink: 0,
                    }}
                  >
                    {svc.emoji}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 700, fontSize: "0.9rem", color: "#1a1a2e" }}>{svc.label}</Typography>
                    <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.75rem", color: "#888", mt: 0.3 }}>{svc.cars.length} خيارات متاحة</Typography>
                  </Box>
                  <ArrowBackIos sx={{ fontSize: 14, color: "#4183c5" }} />
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

// ─── Step 1: Car Selection ────────────────────────────────────────────────────
const CarStep = ({ selectedService, onSelectCar, onBack }) => {
  const availableCars = carsData[selectedService].cars;
  return (
    <Box>
      <Stack direction="row" alignItems="center" gap={1} mb={0.5}>
        <IconButton size="small" onClick={onBack} sx={{ color: "#4183c5" }}>
          <ArrowForwardIos fontSize="small" />
        </IconButton>
        <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.05rem", color: "#1a1a2e" }}>اختر السيارة</Typography>
      </Stack>

      <Box sx={{ mb: 2.5, px: 0.5 }}>
        <Chip
          label={`${carsData[selectedService].emoji} ${carsData[selectedService].label}`}
          sx={{ fontFamily: '"Cairo"', fontWeight: 600, bgcolor: "#f3eeff", color: "#4183c5", fontSize: "0.78rem" }}
        />
      </Box>

      <Grid container spacing={2}>
        {availableCars.map((car) => (
          <Grid item xs={12} sm={6} key={car.id}>
            <Card
              onClick={() => onSelectCar(car)}
              elevation={0}
              sx={{
                borderRadius: 3,
                border: "1.5px solid #e8e0f5",
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": { border: "1.5px solid #4183c5", boxShadow: "0 4px 20px rgba(98,62,151,0.12)", transform: "translateY(-2px)" },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                  <Box>
                    <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1rem", color: "#1a1a2e" }}>{car.model}</Typography>
                  </Box>
                  <Box sx={{ textAlign: "left" }}>
                    <Stack direction="row" alignItems="center" gap={0.3}>
                      <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.1rem", color: "#4183c5" }}>{car.price}</Typography>
                      <SARIcon size={14} color="#4183c5" />
                    </Stack>
                  </Box>
                </Stack>

                <Stack direction="row" gap={1} mt={1.5} flexWrap="wrap">
                  <Chip
                    dir="ltr"
                    icon={<DirectionsCar sx={{ fontSize: "13px !important" }} />}
                    label={car.year}
                    size="small"
                    sx={{ fontFamily: '"Cairo"', fontSize: "0.7rem", bgcolor: "#f5f5f5", height: 22 }}
                  />
                  <Chip label={`${car.seats} مقاعد`} size="small" sx={{ fontFamily: '"Cairo"', fontSize: "0.7rem", bgcolor: "#e8f5e9", color: "#2e7d32", height: 22 }} />
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

// ─── Step 2: Order Form ───────────────────────────────────────────────────────
const FormStep = ({ form, errors, selectedService, selectedCar, totalPrice, submitting, submitError, onFormChange, onSubmit, onBack }) => (
  <Box>
    <Stack direction="row" alignItems="center" gap={1} mb={0.5}>
      <IconButton size="small" onClick={onBack} sx={{ color: "#4183c5" }}>
        <ArrowForwardIos fontSize="small" />
      </IconButton>
      <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.05rem", color: "#1a1a2e" }}>تفاصيل الطلب</Typography>
    </Stack>

    {/* Summary card */}
    <Box sx={{ mb: 3, borderRadius: 3, border: "1.5px solid #e8e0f5", bgcolor: "#faf8ff", overflow: "hidden" }}>
      <Box sx={{ bgcolor: "#4183c5", px: 2, py: 1.2 }}>
        <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 700, fontSize: "0.82rem", color: "#fff" }}>ملخص الطلب</Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        <Stack spacing={1}>
          {[
            { label: "الخدمة", value: carsData[selectedService].label },
            { label: "السيارة", value: selectedCar.model },
            { label: "عدد المقاعد", value: `${selectedCar.seats} مقاعد` },
          ].map(({ label, value }) => (
            <Stack key={label} direction="row" justifyContent="space-between">
              <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.78rem", color: "#888" }}>{label}</Typography>
              <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.82rem", fontWeight: 600, color: "#333" }}>{value}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Box>

    {/* Extra route */}
    {/* <Box sx={{ mb: 3, p: 2, borderRadius: 3, border: "1.5px solid #e8e0f5", bgcolor: "#fafafa" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box sx={{ flex: 1, pr: 1 }}>
          <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 700, fontSize: "0.85rem", color: "#1a1a2e" }}>
            الدخول عبر المسار
            <Typography component="span" sx={{ color: "#4183c5", fontWeight: 800, ml: 0.5 }}>
              (85 ريال)
            </Typography>
          </Typography>
        </Box>
        <Box
          onClick={() => onFormChange("extra_route_access", !form.extra_route_access)}
          sx={{
            width: 44,
            height: 24,
            borderRadius: 12,
            cursor: "pointer",
            bgcolor: form.extra_route_access ? "#4183c5" : "#e0e0e0",
            position: "relative",
            transition: "background-color 0.2s",
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 2,
              left: form.extra_route_access ? 22 : 2,
              width: 20,
              height: 20,
              borderRadius: "50%",
              bgcolor: "#fff",
              transition: "left 0.2s",
              boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
            }}
          />
        </Box>
      </Stack>
    </Box> */}

    {/* Total */}
    <Box sx={{ mb: 3, p: 2, borderRadius: 3, bgcolor: "#f3eeff", border: "1.5px solid #d4b8f5" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 700, fontSize: "0.9rem", color: "#4183c5" }}>الإجمالي</Typography>
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.3rem", color: "#4183c5" }}>{totalPrice}</Typography>
          <SARIcon size={18} color="#4183c5" />
        </Stack>
      </Stack>
    </Box>

    <Divider sx={{ mb: 3 }} />

    {/* Form fields */}
    <Stack spacing={2.5}>
      {/* Name */}
      <TextField
        label="الاسم*"
        value={form.name}
        onChange={(e) => onFormChange("name", e.target.value)}
        error={!!errors.name}
        helperText={errors.name}
        fullWidth
        size="small"
        inputProps={{ dir: "rtl", style: { fontFamily: '"Cairo"' } }}
        InputLabelProps={{ style: { fontFamily: '"Cairo"' } }}
        FormHelperTextProps={{ style: { fontFamily: '"Cairo"', textAlign: "right" } }}
      />
      {/* Phone */}
      <TextField
        label="رقم الجوال*"
        value={form.phone}
        onChange={(e) => onFormChange("phone", e.target.value)}
        error={!!errors.phone}
        helperText={errors.phone}
        fullWidth
        size="small"
        placeholder="+9665xxxxxxxx"
        inputProps={{ dir: "ltr", style: { fontFamily: '"Cairo"' } }}
        InputLabelProps={{ style: { fontFamily: '"Cairo"' } }}
        FormHelperTextProps={{ style: { fontFamily: '"Cairo"', textAlign: "right" } }}
        type="tel"
      />
      {/* Pickup location */}
      <Box>
        <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.82rem", color: "#555", mb: 1, fontWeight: 600 }}>مكان الاستقبال*</Typography>
        <Stack spacing={0.5}>
          {[
            { value: "airport", label: "مطار الملك عبدالعزيز - جدة" },
            { value: "other", label: "اخرى" },
          ].map(({ value, label }) => (
            <Box
              key={value}
              onClick={() => onFormChange("pickup_location", value)}
              sx={{
                px: 2,
                py: 1.2,
                borderRadius: 2,
                cursor: "pointer",
                border: `1.5px solid ${form.pickup_location === value ? "#4183c5" : "#e0e0e0"}`,
                bgcolor: form.pickup_location === value ? "#f3eeff" : "#fff",
                transition: "all 0.15s",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontFamily: '"Cairo"',
                  fontSize: "0.83rem",
                  color: form.pickup_location === value ? "#4183c5" : "#555",
                  fontWeight: form.pickup_location === value ? 700 : 400,
                }}
              >
                {label}
              </Typography>
              {form.pickup_location === value && <CheckCircle sx={{ fontSize: 18, color: "#4183c5" }} />}
            </Box>
          ))}
        </Stack>
      </Box>
      {/* Neighborhood - only if "other" */}
      <Collapse in={form.pickup_location === "other"}>
        <TextField
          label="العنوان*"
          value={form.neighborhood}
          onChange={(e) => onFormChange("neighborhood", e.target.value)}
          error={!!errors.neighborhood}
          helperText={errors.neighborhood}
          fullWidth
          size="small"
          inputProps={{ dir: "rtl", style: { fontFamily: '"Cairo"' } }}
          InputLabelProps={{ style: { fontFamily: '"Cairo"' } }}
          FormHelperTextProps={{ style: { fontFamily: '"Cairo"', textAlign: "right" } }}
        />
      </Collapse>
      {/* Date + Time row */}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="تاريخ الاستقبال*"
            type="date"
            value={form.pickup_date}
            onChange={(e) => onFormChange("pickup_date", e.target.value)}
            error={!!errors.pickup_date}
            helperText={errors.pickup_date}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true, style: { fontFamily: '"Cairo"' } }}
            inputProps={{ style: { fontFamily: '"Cairo"' } }}
            FormHelperTextProps={{ style: { fontFamily: '"Cairo"', textAlign: "right" } }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="ساعة الوصول*"
            type="time"
            value={form.pickup_hour}
            onChange={(e) => onFormChange("pickup_hour", e.target.value)}
            error={!!errors.pickup_hour}
            helperText={errors.pickup_hour}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true, style: { fontFamily: '"Cairo"' } }}
            inputProps={{ style: { fontFamily: '"Cairo"' } }}
            FormHelperTextProps={{ style: { fontFamily: '"Cairo"', textAlign: "right" } }}
          />
        </Grid>
      </Grid>

      {/* File Upload Section */}
      <Box sx={{ mt: 2 }}>
        <Typography
          sx={{
            fontFamily: '"Cairo"',
            fontSize: "0.82rem",
            color: errors.images ? "#d32f2f" : "#555",
            mb: 1,
            fontWeight: 600,
          }}
        >
          إرفاق التذكرة (صورة أو PDF)*
        </Typography>

        <Button
          variant="outlined"
          component="label"
          fullWidth
          sx={{
            fontFamily: '"Cairo"',
            borderStyle: "dashed",
            py: 1.5,
            borderRadius: 2,
            borderColor: errors.images ? "#d32f2f" : "#bbb",
            color: errors.images ? "#d32f2f" : "#666",
            "&:hover": {
              borderColor: "#4183c5",
            },
          }}
        >
          {/* Updated text to be more generic since it's not just "images" anymore */}
          {form.images.length > 0 ? `تم اختيار ${form.images.length} ملفات` : "اضغط هنا لرفع التذكرة"}

          <input
            type="file"
            hidden
            required
            // multiple // Added multiple if you want to allow more than one file
            accept="image/*,application/pdf" // This allows both images and PDFs
            onChange={(e) => onFormChange("images", Array.from(e.target.files))}
          />
        </Button>

        {errors.images && (
          <Typography
            sx={{
              fontFamily: '"Cairo"',
              fontSize: "0.75rem",
              color: "#d32f2f",
              mt: 0.5,
              textAlign: "right",
            }}
          >
            {errors.images}
          </Typography>
        )}

        {/* Preview Thumbnails */}
        {form.images.length > 0 && (
          <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
            {form.images.map((file, idx) => (
              <Chip
                dir="ltr"
                key={idx}
                label={file.name}
                size="small"
                // Optional: Change color if it's a PDF for better UX
                color="default"
                variant="outlined"
                onDelete={() => {
                  const newImages = form.images.filter((_, i) => i !== idx);
                  onFormChange("images", newImages);
                }}
                sx={{ fontFamily: '"Cairo"', fontSize: "0.7rem" }}
              />
            ))}
          </Stack>
        )}
      </Box>

      {/* Hotel (optional) */}
      <TextField
        label="اسم الفندق (اختياري)"
        value={form.hotel_name}
        onChange={(e) => onFormChange("hotel_name", e.target.value)}
        fullWidth
        size="small"
        inputProps={{ dir: "rtl", style: { fontFamily: '"Cairo"' } }}
        InputLabelProps={{ style: { fontFamily: '"Cairo"' } }}
      />
    </Stack>

    {submitError && (
      <Alert severity="error" sx={{ mt: 2.5, fontFamily: '"Cairo"', fontSize: "0.82rem", "& .MuiAlert-icon": { marginRight: 0, marginLeft: "12px" } }}>
        {submitError}
      </Alert>
    )}

    {/* Submit */}
    <Button
      fullWidth
      variant="contained"
      onClick={onSubmit}
      disabled={submitting}
      sx={{
        mt: 3,
        py: 1.4,
        borderRadius: 2.5,
        fontFamily: '"Cairo"',
        fontWeight: 800,
        fontSize: "1rem",
        bgcolor: "#4183c5",
        "&:hover": { bgcolor: "#4e2f7a" },
        boxShadow: "0 4px 20px rgba(98,62,151,0.3)",
      }}
    >
      {submitting ? "جاري الإرسال..." : "تأكيد الطلب"}
    </Button>
  </Box>
);

// ─── Main Component ───────────────────────────────────────────────────────────
export default function TaxiAddOrder() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [step, setStep] = useState(0);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedCar, setSelectedCar] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [successOpen, setSuccessOpen] = useState(false);

  const totalPrice = selectedCar ? selectedCar.price + (form.extra_route_access ? 85 : 0) : 0;

  const handleSelectService = useCallback((key) => {
    setSelectedService(key);
    setSelectedCar(null);
    setStep(1);
  }, []);

  const handleSelectCar = useCallback((car) => {
    setSelectedCar(car);
    setStep(2);
  }, []);

  const handleFormChange = useCallback((field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: null }));
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim() || form.name.trim().length < 3) newErrors.name = "الاسم يجب أن يكون 3 أحرف على الأقل";
    if (!form.phone.trim() || form.phone.trim().length < 9) newErrors.phone = "رقم الجوال غير صحيح";
    if (form.pickup_location === "other" && !form.neighborhood.trim()) newErrors.neighborhood = "العنوان مطلوب";
    if (!form.pickup_date) newErrors.pickup_date = "تاريخ الاستقبال مطلوب";
    if (!form.pickup_hour) newErrors.pickup_hour = "ساعة الوصول مطلوبة";

    // New Validation for Images
    if (!form.images || form.images.length === 0) {
      newErrors.images = "يرجى إرفاق صورة التذكرة للمتابعة";
    }

    return newErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    setSubmitError(null);

    const pickupLocationLabel = form.pickup_location === "airport" ? "مطار جدة" : form.pickup_location === "other" ? "اخرى" : form.pickup_location;

    // Use FormData instead of a simple JSON object
    const formData = new FormData();
    formData.append("type", carsData[selectedService].label);
    formData.append("car_model", selectedCar.model);
    formData.append("seats_number", selectedCar.seats);
    formData.append("price", totalPrice);
    formData.append("name", form.name.trim());
    formData.append("phone", form.phone.trim());
    formData.append("pickup_location", pickupLocationLabel);
    formData.append("neighborhood", form.neighborhood.trim() || "N/A");
    formData.append("pickup_date", form.pickup_date);
    formData.append("pickup_hour", form.pickup_hour);
    formData.append("hotel_name", form.hotel_name.trim() || "");
    formData.append("extra_route_access", form.extra_route_access ? 1 : 0);
    formData.append("status", "pending");

    // Append images
    if (form.images && form.images.length > 0) {
      form.images.forEach((file) => {
        formData.append("images[]", file); // Use images[] syntax for Laravel array handling
      });
    }

    try {
      const res = await fetch(`${API_BASE}/save-taxi-order`, {
        method: "POST",
        // Do NOT set Content-Type header when sending FormData;
        // the browser will set it automatically including the boundary string.
        body: formData,
      });

      const json = await res.json();
      if (json.success || res.ok) {
        setSuccessOpen(true);
      } else {
        setSubmitError(json.message || "حدث خطأ أثناء الإرسال");
      }
    } catch {
      setSubmitError("فشل الاتصال بالخادم");
    }
    setSubmitting(false);
  };

  const handleReset = () => {
    setStep(0);
    setSelectedService(null);
    setSelectedCar(null);
    setForm(initialForm);
    setErrors({});
    setSubmitError(null);
    setSuccessOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800&display=swap" rel="stylesheet" />

      <Box dir="rtl" sx={{ minHeight: "100vh", maxWidth: "750px", margin: "auto" }}>
        {/* Header */}
        <Box sx={{ bgcolor: "#4183c5", px: 2, pt: 3, pb: 4 }}>
          <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.2rem", color: "#fff", textAlign: "center" }}>إضافة طلب جديد</Typography>

          {/* Step dots */}
          <Stack direction="row" justifyContent="center" alignItems="flex-start" mt={2.5} gap={0}>
            <StepDot index={0} currentStep={step} label="الخدمة" />
            <Box sx={{ height: 2, width: 40, bgcolor: "#fff", mt: 1.5, mx: 0.5, borderRadius: 1, transition: "background-color 0.3s" }} />
            <StepDot index={1} currentStep={step} label="السيارة" />
            <Box sx={{ height: 2, width: 40, bgcolor: "#fff", mt: 1.5, mx: 0.5, borderRadius: 1, transition: "background-color 0.3s" }} />
            <StepDot index={2} currentStep={step} label="البيانات" />
          </Stack>
        </Box>

        {/* Content card */}
        <Box sx={{ px: 2, mt: -2 }}>
          <Box sx={{ bgcolor: "#fff", borderRadius: 4, p: 2.5, boxShadow: "0 4px 24px rgba(98,62,151,0.08)", minHeight: 300 }}>
            {step === 0 && <ServiceStep onSelectService={handleSelectService} />}
            {step === 1 && selectedService && <CarStep selectedService={selectedService} onSelectCar={handleSelectCar} onBack={() => setStep(0)} />}
            {step === 2 && selectedService && selectedCar && (
              <FormStep
                form={form}
                errors={errors}
                selectedService={selectedService}
                selectedCar={selectedCar}
                totalPrice={totalPrice}
                submitting={submitting}
                submitError={submitError}
                onFormChange={handleFormChange}
                onSubmit={handleSubmit}
                onBack={() => setStep(1)}
              />
            )}
          </Box>
        </Box>

        <Box sx={{ height: 40 }} />
      </Box>

      {/* Success Dialog */}
      <Dialog open={successOpen} maxWidth="xs" fullWidth dir="rtl" PaperProps={{ sx: { borderRadius: 4, fontFamily: '"Cairo"', textAlign: "center", overflow: "hidden" } }}>
        <Box sx={{ bgcolor: "#4183c5", py: 3, px: 2 }}>
          <Typography sx={{ fontFamily: '"Cairo"', fontWeight: 800, fontSize: "1.1rem", color: "#fff", mt: 1 }}>تم تأكيد الطلب بنجاح!</Typography>
        </Box>
        <DialogContent sx={{ py: 3 }}>
          <Box sx={{ mt: 2, borderRadius: 2, p: 2, textAlign: "right" }}>
            {[
              { label: "الخدمة", value: selectedService ? carsData[selectedService].label : "" },
              { label: "السيارة", value: selectedCar ? selectedCar.model : "" },
              { label: "الإجمالي", value: `${totalPrice} ريال`, bold: true },
            ].map(({ label, value, bold }) => (
              <Stack key={label} direction="row" justifyContent="space-between" mb={0.5}>
                <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.78rem", color: "#888" }}>{label}</Typography>
                <Typography sx={{ fontFamily: '"Cairo"', fontSize: "0.82rem", fontWeight: bold ? 800 : 600, color: bold ? "#4183c5" : "#333" }}>{value}</Typography>
              </Stack>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3, gap: 1.5 }}>
          <Button
            onClick={handleReset}
            variant="contained"
            sx={{ fontFamily: '"Cairo"', fontWeight: 700, borderRadius: 2, bgcolor: "#4183c5", "&:hover": { bgcolor: "#4e2f7a" }, px: 3 }}
          >
            طلب جديد
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
